import gql from 'graphql-tag';

export const AGENT_DETAILS_FRAGMENT = gql`
    fragment AGENT_DETAILS_FRAGMENT on ListingData {
        branch {
            branchDetailsUri
            branchResultsUri
            logoUrl
            phone
            name
            memberType
        }
    }
`;
